import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const TaxonomyContext = createContext({});

export function TaxonomyProvider({ children }) {
  const [tax, setTax] = useState(null);
  useEffect(() => {
    api.get("/taxonomy").then((r) => setTax(r.data)).catch(() => {});
  }, []);
  return <TaxonomyContext.Provider value={tax || {}}>{children}</TaxonomyContext.Provider>;
}

export const useTaxonomy = () => useContext(TaxonomyContext);
